import React from 'react';
import ReactDOM from 'react-dom';
import { createServer, Model } from 'miragejs';
import App from './App';

createServer({
  models: {
    transaction: Model,
  },

  seeds(server) {
    server.db.loadData({
      transactions: [
        {
          id: 1,
          description: 'Freelance de website',
          type: 'deposit',
          category: 'Dev',
          amount: 3000,
          createdAt: new Date('2021-02-12 09:00:00'),
        },
        {
          id: 2,
          description: 'Aluguel',
          type: 'withdraw',
          category: 'Casa',
          amount: 780,
          createdAt: new Date('2021-02-14 11:00:00'),
        },
      ],
    })
  },

  routes () {
    this.namespace = 'api';

    this.get('/transactions', () => {
      return this.schema.all('transaction')
    });

    this.post('/transactions', (schema, request) =>  {
      const data = JSON.parse(request.requestBody)

      return schema.create('transaction', data)
    })
  }
})

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);


